import React from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import {claimTypes} from "../../../../constants/claim.constants";
import {connect} from "react-redux";

const WidgetSceneDaliEsSystemManagement = ({daliList, callbackAction, user, claim, t, pilot = false}) => {
    let claimAccess;
    if(!pilot) {
        claimAccess = user[`c_${claim}`] || null;
    } else {
        claimAccess = "readWrite";
    }

    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    const handleActions = (action) => {
        callbackAction(action);
    };

    const selectIcon = (scene) => {
        let icon = '';
        if (scene.isDefault === null) { icon = 'fas fa-power-off'; }
        else if (scene.isDefault === false) { icon = 'far fa-lightbulb' }
        else { icon = 'fas fa-sun'; }
        return icon;
    };

    const devices = daliList?.map((device) => {
        const lightArea = device.daliEsSystemArea.map((daliArea, idx) => {
            const lightGroup = daliArea.daliEsSystemGroups.map((daliGroup) => {
                const renderButtons = daliGroup.daliEsSystemScenes.map((daliScene) => {
                    return (
                        <Button variant="outline-primary"
                                active={daliScene.isActive}
                                className="m-1"
                                key={daliScene.id}
                                disabled={claimAccess === (claimTypes.READ)}
                                onClick={() => { handleActions(`ChangeDaliEsSystemScene?id=${device.id}&sceneId=${daliScene.id}`) }}>
                            <i className={selectIcon(daliScene)}> </i> &nbsp;
                            {daliScene.label}
                        </Button>
                    );
                });

                return (
                    <div className="list-group-item list-group-item-action" key={"dali-group" + daliGroup.id}>
                        <div className="row">
                            <div className="col-md-3 d-flex">
                                <span className="text-wrap font-weight-bold align-self-center">{daliGroup.label}</span>
                            </div>
                            <div className="col-md-9">
                                <div className="flex-wrap">
                                    { renderButtons }
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });

            return lightGroup;
        })


        return (
            <div className="card my-2" key={device.id}>
                <div className="card-header">
                    <div className="card-title d-flex w-100">
                        <b className="align-self-center">{device.label}</b>
                        <div className="ml-auto d-flex">
                            <Button className="m-1"
                                    active={!device.diagnosticMode}
                                    variant="outline-success"
                                    disabled={claimAccess === (claimTypes.READ)}
                                    onClick={() => handleActions(`AutomaticEsSystem?id=${device.id}`)}>
                                <i className="fas fa-sync"> </i> &nbsp; Auto
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="list-group mx-2">
                        { lightArea }
                    </div>
                </div>
            </div>
        );
    });


    return (
        <div className="mt-2">
            { devices?.length ? (
                devices
            ) : (
                <div className="card">
                    <div className="card-header"><span className="card-title">Light scenes</span></div>
                    <div className="card-body">
                        <div className="text-center p-4">
                            <h3>{ t('dali-no-content') }</h3>
                        </div>
                    </div>
                </div>
            ) }
        </div>
    );
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetSceneDaliEsSystemManagement));
